/* eslint-disable @typescript-eslint/naming-convention */
import React from 'react'
import { Moment } from 'moment'
import moment from 'moment/moment'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { DatePicker as MuiDatePicker } from '@mui/x-date-pickers/DatePicker'
import { colors } from '@resiliatech/birdsong'

type DatePickerProps = {
  clearable?: boolean
  date: string | undefined | null | Moment
  label?: string
  onClear?: () => void
  onDateSelected: (date: Moment | null) => void
  styles?: Record<string, unknown>
  props?: Record<string, unknown>
  slotProps?: Record<string, unknown>
}

export const DatePicker = ({
  clearable = true,
  date,
  props,
  label,
  onClear,
  onDateSelected,
  styles,
}: DatePickerProps) => (
  <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale='en-us'>
    <MuiDatePicker
      label={label || ''}
      value={date ? moment.utc(date) : null}
      onChange={(newDate): void => {
        onDateSelected(newDate ?? null)
      }}
      slotProps={{
        textField: {
          InputProps: {
            placeholder: '',
          },
          size: 'small',
        },
        field: { clearable, onClear: onClear || undefined },
      }}
      sx={{
        '.MuiFormLabel-root': { backgroundColor: 'inherit' },
        '.MuiSvgIcon-root': { color: colors.primary.main },
        minWidth: '175px',
        ...styles,
      }}
      {...props}
    />
  </LocalizationProvider>
)
